<template>
    <footer class="cl-footer">
        <!-- sponsors: white tiles on the charcoal, each with its title -->
        <div class="cl-footer__sponsors">
            <div class="cl-footer__inner">
                <div class="cl-footer__heading">Sponsors &amp; Partners</div>
                <div class="cl-footer__sponsor-grid">
                    <button
                        v-for="sponsor in sponsors"
                        :key="sponsor.key"
                        type="button"
                        class="cl-footer__sponsor"
                        @click="openSocial(sponsor.key)"
                    >
                        <span class="cl-footer__sponsor-label">{{ sponsor.label }}</span>
                        <span class="cl-footer__sponsor-logo">
                            <img :src="sponsor.image" :alt="sponsor.label">
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="cl-footer__inner cl-footer__columns">
            <div class="cl-footer__brand">
                <img class="cl-footer__logo" :src="require('@/assets/commercial-league-inline-logo.png')" alt="Commercial League">
                <p class="cl-footer__about">
                    Αποτελέσματα, πρόγραμμα, βαθμολογίες και στατιστικά του Commercial League.
                </p>
                <div class="cl-footer__label">Follow us</div>
                <div class="cl-footer__socials">
                    <button v-for="social in socials" :key="social.key" type="button" class="cl-footer__social" :title="social.key" @click="openSocial(social.key)">
                        <v-icon small>{{ social.icon }}</v-icon>
                    </button>
                </div>
            </div>
            <div>
                <div class="cl-footer__label">Pages</div>
                <router-link v-for="link in pages" :key="link.name" :to="{ name: link.name }" class="cl-footer__link">{{ link.text }}</router-link>
            </div>
            <div>
                <div class="cl-footer__label">The League</div>
                <router-link v-for="link in league" :key="link.name" :to="{ name: link.name }" class="cl-footer__link">{{ link.text }}</router-link>
            </div>
        </div>

        <div class="cl-footer__bottom">
            <div class="cl-footer__inner">
                © {{ year }} Commercial League
            </div>
        </div>
    </footer>
</template>

<script>
    import { openSocial, SPONSORS } from '@/utils/social'

    export default {
        name: 'CustomFooter',
        data() {
            return {
                sponsors: SPONSORS,
                socials: [
                    { key: 'facebook', icon: 'mdi-facebook' },
                    { key: 'instagram', icon: 'mdi-instagram' },
                    { key: 'youtube', icon: 'mdi-youtube' },
                    { key: 'twitter', icon: 'mdi-twitter' },
                    { key: 'linkedin', icon: 'mdi-linkedin' }
                ],
                pages: [
                    { name: 'Home', text: 'Αρχική' },
                    { name: 'News', text: 'Νέα' },
                    { name: 'Teams', text: 'Ομάδες' },
                    { name: 'Courts', text: 'Γήπεδα' },
                    { name: 'Profile', text: 'Προφίλ' }
                ],
                league: [
                    { name: 'Register', text: 'Εγγραφή ομάδας' },
                    { name: 'Regulations', text: 'Κανονισμός' },
                    { name: 'ContactUs', text: 'Επικοινωνία' },
                    { name: 'PrivacyPolicy', text: 'Πολιτική απορρήτου' }
                ],
                year: new Date().getFullYear()
            }
        },
        methods: {
            openSocial
        }
    }
</script>

<style scoped>
.cl-footer {
    position: relative;
    margin-top: 40px;
    background: #232323;
    color: rgba(255, 255, 255, 0.75);
    font-family: Roboto, Arial, sans-serif;
    text-align: left;
}

.cl-footer::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 4px;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
}

.cl-footer__inner {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 24px;
}

.cl-footer__sponsors {
    padding: 36px 0 28px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.cl-footer__heading {
    margin-bottom: 18px;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.8rem;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.cl-footer__sponsor-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 14px;
}

.cl-footer__sponsor {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
    text-align: left;
    cursor: pointer;
}

.cl-footer__sponsor-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #03e5b7;
}

.cl-footer__sponsor-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 96px;
    padding: 10px;
    border-radius: 8px;
    background: #fff;
    transition: transform 0.15s, box-shadow 0.15s;
}

.cl-footer__sponsor:hover .cl-footer__sponsor-logo {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(3, 229, 183, 0.25);
}

.cl-footer__sponsor-logo img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.cl-footer__columns {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 32px;
    padding-top: 36px;
    padding-bottom: 36px;
}

.cl-footer__logo {
    width: 240px;
    max-width: 100%;
    margin-bottom: 12px;
}

.cl-footer__about {
    max-width: 360px;
    margin-bottom: 18px;
    font-size: 0.9rem;
    line-height: 1.5;
}

.cl-footer__label {
    margin-bottom: 10px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #fff;
}

.cl-footer__link {
    display: block;
    padding: 4px 0;
    color: rgba(255, 255, 255, 0.7) !important;
    text-decoration: none;
    font-size: 0.92rem;
}

.cl-footer__link:hover {
    color: #03e5b7 !important;
}

.cl-footer__socials {
    display: flex;
    gap: 8px;
}

.cl-footer__social {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    transition: background 0.15s;
}

.cl-footer__social .v-icon {
    color: #fff !important;
}

.cl-footer__social:hover {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

.cl-footer__bottom {
    padding: 14px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 800px) {
    .cl-footer__columns {
        grid-template-columns: 1fr 1fr;
    }

    .cl-footer__brand {
        grid-column: 1 / -1;
    }
}

/* phones: a tighter footer, two sponsors per row */
@media (max-width: 600px) {
    .cl-footer {
        margin-top: 28px;
    }

    .cl-footer__inner {
        padding: 0 16px;
    }

    .cl-footer__sponsors {
        padding: 26px 0 20px;
    }

    .cl-footer__heading {
        font-size: 1.4rem;
    }

    .cl-footer__sponsor-grid {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
}
</style>
